import axios from "@/axios/defaultAxios";
import { serializeQueryParams } from "@/utils/utils";

import { endpoints } from "./constants";

/**
 * @param {object} params - a filters that will filter the datasets list
 */
export const getDatasetsList = async (params) => {
  const url = endpoints.DATASET_LIST + (params ? `?${serializeQueryParams(params)}` : "");
  return await axios.get(url);
};

/**
 * @param {string} id - dataset id
 */
export const getDataset = async (id) => {
  const url = endpoints.DATASET_SHOW.replace(":id", id);
  return await axios.get(url);
};
